// @ts-nocheck
import Keycloak from "keycloak-js/dist/keycloak.js";

let _keycloak = new Keycloak({
    'url': 'https://sso.buschgroup.com/auth/',
    'realm': 'pv-services',
    'clientId': 'price-calculator-public'
})

export default class KeycloakService {
    static getInstance = (keycloakObject?: any) => {
        if(keycloakObject) { // @ts-ignore
            _keycloak = new Keycloak({...keycloakObject});
        }
        return _keycloak
    }

    static init = () => {
        return _keycloak.init({
            onLoad: 'login-required',
        })
    }

    static logout = () => {
        if (!_keycloak) return Promise.resolve();

        try {
            if (_keycloak.clearToken) {
                _keycloak.clearToken();
            }
            window.sessionStorage.removeItem('token');
            return _keycloak.logout({
                redirectUri: window.location.href,
            });

        } catch (e) {
            return Promise.resolve()
        }
    }
};
